import React from "react";
import { QRCodeSVG } from "qrcode.react";

/**
 * Etiqueta de crachá 95 mm × 40 mm.
 * QR Code apenas para usuários do tipo "convidado".
 */
const EtiquetaCracha = ({ nome, cargo, empresa, id, tipo, mostrarQr }) => {
  const exibirQr =
    mostrarQr !== undefined
      ? mostrarQr
      : tipo === "convidado" && id != null && id !== "";

  return (
    <div
      className={`etiqueta-cracha${exibirQr ? "" : " etiqueta-cracha--sem-qr"}`}
    >
      <div className="etiqueta-cracha__texto">
        <div className="etiqueta-cracha__nome">{nome || "—"}</div>
        {cargo ? <div className="etiqueta-cracha__cargo">{cargo}</div> : null}
        {empresa ? (
          <div className="etiqueta-cracha__empresa">{empresa}</div>
        ) : null}
      </div>
      {exibirQr ? (
        <div className="etiqueta-cracha__qr">
          <QRCodeSVG
            value={String(id)}
            size={64}
            level="M"
            includeMargin={false}
            className="etiqueta-cracha__qr-svg"
          />
        </div>
      ) : null}
    </div>
  );
};

export default EtiquetaCracha;
